import { render, staticRenderFns } from "./modalRegistrarTransferencia.vue?vue&type=template&id=c47e491a&scoped=true"
import script from "./modalRegistrarTransferencia.vue?vue&type=script&lang=js"
export * from "./modalRegistrarTransferencia.vue?vue&type=script&lang=js"
import style0 from "./modalRegistrarTransferencia.vue?vue&type=style&index=0&id=c47e491a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47e491a",
  null
  
)

export default component.exports